import React, { useEffect, useState } from "react";
import "./FloatingAIButton.css";
import { aiStartButton } from "../../assets/images/images";
import useBranding from "../../hooks/useBranding";
/**
 * FloatingAIButton - A reusable floating action button component for AI Assistant
 * 
 * @param {Function} onClick - Click handler function (required)
 * @param {string} bottom - Bottom position (default: "60px")
 * @param {string} right - Right position (default: "40px")
 * @param {string} size - Button size in pixels (default: "60px")
 * @param {boolean} disabled - Whether the button is disabled
 * @param {string} className - Additional CSS classes
 */
const FloatingAIButton = ({
  onClick,
  bottom = window?.innerWidth <= 640 ? "35px" : "60px",
  right = window?.innerWidth <= 640 ? "23px" : "40px",
  size = "60px",
  disabled = false,
  className = "",

}) => {
  const buttonStyle = {
    bottom,
    right,
    "--button-size": size,
  };
 
  const brandconfig = useBranding();
  const imageSrc = brandconfig.chatbotlogo || aiStartButton;
  const altText = "AI Assistant";
  const ariaLabel = "Open AI Assistant";
    const [showWelcomeTooltip, setShowWelcomeTooltip] = useState(false);
  
  useEffect(() => {
    const dismissed = localStorage.getItem('chatbot_welcome_dismissed');
    if (!dismissed) {
      setShowWelcomeTooltip(true);
    }
  }, []);

  const handleButtonClick = (e) => {
  // Hide + persist dismissal when the chatbot is opened
  if (showWelcomeTooltip) {
    handleDismissTooltip();
  }
  onClick?.(e); // still open the chatbot; optional chaining guards missing prop
};
  
  const handleDismissTooltip = () => {
    setShowWelcomeTooltip(false);
    localStorage.setItem('chatbot_welcome_dismissed', 'true');
  };

  return (
   <>
    <button
      className={`floating-ai-button ${className}`}
      style={buttonStyle}
        onClick={handleButtonClick}
      // onClick={onClick} if any issue occurs just uncomment this line and comment the above line
      disabled={disabled}
      aria-label={ariaLabel}
      type="button"
    >
      <img src={imageSrc} alt={altText} />
    </button>
    
      {showWelcomeTooltip  && (
  <div style={{
    position: 'fixed',
    bottom: '90px',       // sits above your chat launcher button
    right: '24px',
    zIndex: 9999,
    animation: 'tooltipPopIn 0.25s cubic-bezier(.34,1.56,.64,1) both',
  }}>
    <div style={{
      position: 'relative',
      background: '#fff',
      border: '1px solid #e5e7eb',
      borderRadius: '16px 16px 4px 16px',
      padding: '14px 40px 14px 16px',
      maxWidth: '270px',
      boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
          bottom: '37px',
    right: '51px',
    }} className="floating-ai-tooltip">
      {/* Close button */}
      <button
        onClick={handleDismissTooltip}
        style={{
          position: 'absolute', top: 8, right: 8,
          width: 22, height: 22, borderRadius: '50%',
          border: 'none', background: '#f3f4f6',
          cursor: 'pointer', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          fontSize: 13, color: '#6b7280',
        }}
        aria-label="Dismiss"
      >
        ✕
      </button>

      {/* <p style={{ fontSize: 16, margin: '0 0 4px' }}>👋</p> */}
      <p style={{ fontSize: 14, margin: 0, lineHeight: 1.5, color: '#111' }}>
       Hi! How can I help you today?
      </p>

      {/* Tail pointing down toward the launcher button */}
      <div style={{
        position: 'absolute', bottom: -10, right: 18,
        width: 0, height: 0,
        borderLeft: '10px solid transparent',
        borderTop: '10px solid #fff',
      }} />
    </div>
  </div>
)}
   </>
  );
};

export default FloatingAIButton;

